import React, { useRef, useEffect } from "react";
import { useAuth } from "@/lib/AuthContext";
import GiveawayHeader from "../components/giveaway/GiveawayHeader";
import FootballBackground from "../components/giveaway/FootballBackground";
import HeroSection from "../components/giveaway/HeroSection";
import AboutMom3ntum from "../components/giveaway/AboutMom3ntum";
import PricingTable from "../components/giveaway/PricingTable";
import GiveawayRaffle from "../components/giveaway/GiveawayRaffle";
import HowItWorks from "../components/giveaway/HowItWorks";
import PrizesSection from "../components/giveaway/PrizesSection";
import SignUpCTASection from "../components/campaign/SignUpCTASection";
import LandingTasksSection from "../components/campaign/LandingTasksSection";

export default function Giveaway() {
  const tasksRef = useRef(null);
  const { isAuthenticated: loggedIn } = useAuth();

  const scrollToTasks = () => tasksRef.current?.scrollIntoView({ behavior: "smooth" });

  // Save referral code from URL immediately (processed in TokenBridge after login)
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const refCode = params.get("ref");
    if (refCode) {
      sessionStorage.setItem("pending_referral", refCode);
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  return (
    <div className="min-h-screen" style={{ background: "#111827", position: "relative", zIndex: 1 }}>
      <FootballBackground />
      <GiveawayHeader />
      <HeroSection onScrollToForm={loggedIn ? scrollToTasks : undefined} loggedIn={loggedIn} />
      <AboutMom3ntum />
      <PricingTable />
      <GiveawayRaffle onScrollToForm={loggedIn ? scrollToTasks : undefined} loggedIn={loggedIn} />
      <HowItWorks onScrollToForm={loggedIn ? scrollToTasks : undefined} loggedIn={loggedIn} />
      <PrizesSection />
      {loggedIn ? (
        <div ref={tasksRef}>
          <LandingTasksSection theme="dark" />
        </div>
      ) : (
        <SignUpCTASection theme="dark" returnPath="/Giveaway" />
      )}
    </div>
  );
}